export const handleEnterKeyPress = (functionToBeExecuted: () => void) => (event: React.KeyboardEvent<HTMLInputElement>): void => {
    const keyCode = event.which;
    if (keyCode === 13) {
        functionToBeExecuted();
    }
};
